<template>
  <div class="container">
    <!-- 顶部导航栏 -->
    <HeadTab></HeadTab>
    <div class="head" id="jump0">
      <div class="head_intro">
        <div class="head_copy">
          <div class="head_tit">Получите кредит до</div>
          <div class="head_text">185 000 тенге</div>
          <div class="iur">Мгновенные займы на карту любого банка Казахстана. Без справок, залога и скрытых комиссий.</div>
        </div>
        <!-- 额度 -->
        <LoanCard></LoanCard>
      </div>
      <div class="hero_visual">
        <div class="hero_circle hero_circle-blue"></div>
        <div class="hero_circle hero_circle-green"></div>
        <img class="oiw" src="/static/img/Group_103.png" alt="Получить кредит" />
      </div>
    </div>
    <!-- 头部下面 -->
    <div class="headMinu">
      <div class="iuh">Почему выбирают KZcredit?</div>
      <div class="lwq">Мы делаем процесс получения кредита максимально простым и удобным</div>
      <div class="headMinu_cen">
        <div class="cen">
          <img class="cen_img" src="/static/img/Group_87.png" alt="" />
          <div class="cen_tit">Мгновенное решение</div>
          <div class="cen_text">Автоматизированная система принимает решение по заявке за 2 минуты. Вам не нужно долго ждать ответа.</div>
        </div>
        <div class="cen">
          <img class="cen_img" src="/static/img/Group_92.png" alt="" />
          <div class="cen_tit">Без справок и залога</div>
          <div class="cen_text">Для получения кредита нужны только удостоверение личности и банковская карта. Без никаких дополнительных документов.</div>
        </div>
        <div class="cen">
          <img class="cen_img" src="/static/img/Group_93.png" alt="" />
          <div class="cen_tit">Без скрытых комиссий</div>
          <div class="cen_text">Все условия прозрачны и указаны в договоре. Вы точно знаете, сколько и когда нужно вернуть.</div>
        </div>
      </div>
      <div class="headMinu_cen" style="margin-top: 0.13rem;">
        <div class="cen">
          <img class="cen_img" src="/static/img/Group_90.png" alt="" />
          <div class="cen_tit">На любую карту</div>
          <div class="cen_text">Переводим деньги на карту любого банка Казахстана. Вы получите деньги в течение 15 минут.</div>
        </div>
        <div class="cen">
          <img class="cen_img" src="/static/img/Group_91.png" alt="" />
          <div class="cen_tit">Гибкие условия</div>
          <div class="cen_text">Вы сами выбираете сумму и срок кредита. Можно погасить кредит досрочно без штрафов.</div>
        </div>
        <div class="cen">
          <img class="cen_img" src="/static/img/Group_88.png" alt="" />
          <div class="cen_tit">Безопасно и законно</div>
          <div class="cen_text">Мы работаем по лицензии Национального Банка Казахстана. Ваши данные надежно защищены.</div>
        </div>
      </div>
    </div>
    <!-- 中间 -->
    <div class="minu">
      <div class="minu_tit">Как получить кредит в KZcredit?</div>
      <div class="minu_text">Весь процесс занимает не более 15 минут</div>
      <div>
        <div class="olr">
          <div class="iub">1</div>
          <div class="iuv"></div>
          <div class="iub">2</div>
          <div class="iuv"></div>
          <div class="iub">3</div>
          <div class="iuv"></div>
          <div class="iub">4</div>
        </div>
        <div class="iue">
          <div class="iuy" style="margin-right: 0.27rem;">
            <div class="lds">Заполните заявку</div>
            <div class="mnf">Введите ваши данные в простой онлайн-форме на сайте.</div>
          </div>
          <div class="iuy" style="margin-right: 0.27rem;">
            <div class="lds">Получите решение</div>
            <div class="mnf">Система рассмотрит заявку и примет решение за 2 минуты.</div>
          </div>
          <div class="iuy" style="margin-right: 0.27rem;">
            <div class="lds">Подпишите договор</div>
            <div class="mnf">Ознакомьтесь с условиями и подпишите договор SMS-кодом.</div>
          </div>
          <div class="iuy">
            <div class="lds">Получите деньги</div>
            <div class="mnf">Деньги будут переведены на вашу банковскую карту.</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 中间第二部分 -->
    <div class="minuTwo">
      <div class="oaq">Как получить кредит в KZcredit?</div>
      <div class="opw">Для получения микрозайма нужно соответствовать нескольким простым требованиям</div>
      <div class="iut">
        <div>
          <div class="iun" style="margin-bottom: 0.13rem;">
            <img class="ikn" src="/static/img/Group_97.png" alt="" />
            <div class="mls">
              <div class="njd">Гражданство Казахстана</div>
              <div class="iuf">Вы должны быть гражданином Республики Казахстан и иметь постоянную регистрацию на территории страны.</div>
            </div>
          </div>
          <div class="iun" style="margin-bottom: 0.13rem;">
            <img class="ikn" src="/static/img/Group_97.png" alt="" />
            <div class="mls">
              <div class="njd">Действующий паспорт РК</div>
              <div class="iuf">Наличие действующего паспорта гражданина Республики Казахстан с неистекшим сроком действия.</div>
            </div>
          </div>
          <div class="iun" style="margin-bottom: 0.13rem;">
            <img class="ikn" src="/static/img/Group_97.png" alt="" />
            <div class="mls">
              <div class="njd">Действительное удостоверение личности РК</div>
              <div class="iuf">Наличие  действительного удостоверения личности Республики Казахстан  с неистекшим сроком действия.</div>
            </div>
          </div>
          <div class="iun" style="margin-bottom: 0.13rem;">
            <img class="ikn" src="/static/img/Group_97.png" alt="" />
            <div class="mls">
              <div class="njd">Банковская карта</div>
              <div class="iuf">Наличие активной банковской карты любого банка Казахстана, выпущенной на ваше имя.</div>
            </div>
          </div>
          <div class="iun">
            <img class="ikn" src="/static/img/Group_97.png" alt="" />
            <div class="mls">
              <div class="njd">Мобильный телефон</div>
              <div class="iuf">Наличие активного номера мобильного телефона, зарегистрированного на ваше имя.</div>
            </div>
          </div>
        </div>
        <img class="pom" src="/static/img/Group_104.png" alt="" />
      </div>
    </div>
    <!-- 底部 -->
    <BomTab :jumpindex="0"></BomTab>
  </div>
</template>
<script>
  import BomTab from '@/components/BomTab.vue'
  import HeadTab from '@/components/HeadTab.vue'
  import LoanCard from '@/components/loancard.vue'
  export default {
    name: "home",
    data() {
      return {};
    },
    components: {
      BomTab,
      HeadTab,
      LoanCard
    },
    mounted () {
    },
    methods: {

    },
  };
</script>
<style scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .head{
    background: linear-gradient(180deg, #eff6ffff 0%, #dcebfeff 100%);
    padding: 0.54rem 1.58rem 0.9rem;
    margin-bottom: 0.63rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
  }
  .head_intro{
    position: relative;
    z-index: 2;
  }
  .head_copy{
    margin-bottom: 0.21rem;
  }
  .head_tit{
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.29rem;
    margin-bottom: 0.1rem;
  }
  .head_text{
    color: rgba(0, 102, 204, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.29rem;
    margin-bottom: 0.08rem;
  }
  .iur{
    width: 3.35rem;
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.13rem;
    line-height: 0.19rem;
    text-align: left;
  }
  .hero_visual{
    position: relative;
    width: 4.64rem;
    height: 4.2rem;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  .hero_circle{
    position: absolute;
    border-radius: 50%;
    filter: blur(0.01rem);
  }
  .hero_circle-blue{
    width: 0.9rem;
    height: 0.9rem;
    background: rgba(98, 149, 233, 0.18);
    top: 0.22rem;
    left: 0.12rem;
  }
  .hero_circle-green{
    width: 0.58rem;
    height: 0.58rem;
    background: rgba(224, 237, 210, 0.8);
    left: -0.12rem;
    bottom: 0.42rem;
  }
  .oiw{
    width: 4.14rem;
    height: 3.84rem;
    position: relative;
    z-index: 2;
    border-radius: 0.14rem;
    box-shadow: 0rem 0.1rem 0.22rem rgba(51, 65, 85, 0.18);
  }
  .headMinu{
    padding: 0 1.58rem;
    margin-bottom: 0.63rem;
  }
  .iuh{
    text-align: center;
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.27rem;
    margin-bottom: 0.06rem;
  }
  .lwq{
    text-align: center;
    color: rgba(102, 102, 102, 1);
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.13rem;
    margin-bottom: 0.42rem;
  }
  .headMinu_cen{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cen{
    height: 1.2rem;
    border-radius: 0.08rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0rem 0.05rem 0.08rem rgba(0, 0, 0, 0.1), 0rem 0rem 0.03rem rgba(0, 0, 0, 0.1);
    padding: 0.21rem 0.21rem 0.43rem;
  }
  .cen_img{
    width: 0.45rem;
    height: 0.45rem;
    margin-bottom: 0.13rem;
  }
  .cen_tit{
    width: 1.64rem;
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.14rem;
    text-align: left;
    margin-bottom: 0.08rem;
  }
  .cen_text{
    width: 1.78rem;
    color: rgba(102, 102, 102, 1);
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.08rem;
    line-height: 0.1rem;
    text-align: left;
  }
  .minu{
    background: #F2F7FCFF;
    padding: 0.68rem 1.59rem 0.68rem;
    margin-bottom: 0.83rem;
  }
  .minu_tit{
    text-align: center;
    color: #333333ff;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.27rem;
    margin-bottom: 0.06rem;
  }
  .minu_text{
    text-align: center;
    color: #666666ff;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.13rem;
    margin-bottom: 0.52rem;
  }
  .olr{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0 auto 0.21rem;
  }
  .iue{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .iub{
    width: 0.57rem;
    height: 0.57rem;
    line-height: 0.47rem;
    text-align: center;
    border-radius: 0.29rem;
    border: 0.03rem solid #0066ccff;
    box-sizing: border-box;
    background: #ffffffff;
    color: #0066ccff;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.21rem;
  }
  .lds{
    text-align: center;
    color: #333333ff;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 0.15rem;
    margin-bottom: 0.1rem;
  }
  .mnf{
    text-align: center;
    color: #666666ff;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.08rem;
  }
  .iuv{
    width: 1.21rem;
    height: 0.03rem;
    background: #e5e7ebff;
  }
  .minuTwo{
    padding-left: 1.58rem;
    padding-right: 1.59rem;
    margin-bottom: 0.63rem;
  }
  .oaq{
    color: #333333ff;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.27rem;
    text-align: left;
    margin-bottom: 0.06rem;
  }
  .opw{
    width: 5.09rem;
    color: #666666ff;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.13rem;
    text-align: left;
    margin-bottom: 0.31rem;
  }
  .iut{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .iun{
    width: 3.8rem;
    border-radius: 0.08rem;
    background: #f9fafbff;
    padding: 0.14rem 0.13rem 0.17rem;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }
  .ikn{
    width: 0.27rem;
    height: 0.27rem;
    margin-right: 0.08rem;
  }
  .njd{
    color: #333333ff;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 0.13rem;
    margin-bottom: 0.06rem;
  }
  .iuf{
    width: 3.19rem;
    color: #666666ff;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.09rem;
    line-height: 0.11rem;
  }
  .pom{
    width: 2.77rem;
    height: 3.45rem;
  }

  @media screen and (max-width: 1200px) {
    .head,
    .headMinu,
    .minu,
    .minuTwo,
    .bom {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
    .head {
      gap: 0.3rem;
    }
    .head_tit,
    .head_text {
      font-size: 0.3rem;
      line-height: 0.38rem;
    }
    .iur {
      width: 3.4rem;
    }
    .hero_visual {
      width: 3.9rem;
      height: 3.8rem;
    }
    .oiw {
      width: 3.6rem;
      height: 3.34rem;
    }
  }

  @media screen and (max-width: 768px) {
    .head {
      padding-top: 0.42rem;
      flex-direction: column;
      align-items: flex-start;
    }
    .head_intro,
    .hero_visual,
    .iur,
    .oiw {
      width: 100%;
    }
    .head_tit,
    .head_text {
      font-size: 0.24rem;
      line-height: 0.3rem;
    }
    .hero_visual {
      height: auto;
      margin-top: 0.22rem;
    }
    .oiw {
      height: auto;
    }
    .hero_circle-blue {
      width: 0.62rem;
      height: 0.62rem;
      left: 0.02rem;
    }
    .hero_circle-green {
      width: 0.42rem;
      height: 0.42rem;
      left: -0.04rem;
      bottom: 0.18rem;
    }
  }

  .minuTwo_con{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.26rem;
  }
  .minuTwo_con-tit{
    width: 2.7rem;
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 0.21rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 0.09rem;
  }
  .minuTwo_con-tit span{
    color: #13A6B6;
  }
  .minuTwo-m{
    width: 1.15rem;
    height: 0.54rem;
    background: #F6F6F6;
    border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
    padding: 0.21rem 0.17rem 0.29rem;
  }
  .minuTwo-m-img{
    width: 0.21rem;
    height: 0.21rem;
    margin-bottom: 0.1rem;
  }
  .minuTwo-m-text{
    font-family: Montserrat, Montserrat;
    font-weight: 600;
    font-size: 0.09rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .minuThree{
    background-image: url(/static/img/bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 0.86rem 0rem 0.03rem;
  }
  .minuThree_tit{
    width: 2.92rem;
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 0.21rem;
    color: #333333;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 0 auto 0.31rem;
  }
  .minuThree_con{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.83rem 0 2.9rem;
    margin-bottom: 0.21rem;
  }
  .minuThree_con-m{
    width: 2.04rem;
    background: #FFFFFF;
    border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
    padding: 0.22rem 0.26rem;
  }
  .minuThree_con-m-tit{
    font-family: Montserrat, Montserrat;
    font-weight: 600;
    font-size: 0.09rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 0.06rem;
  }
  .minuThree_con-m-text{
    font-family: Montserrat, Montserrat;
    font-weight: 500;
    font-size: 0.08rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .minuThree_con-m-text span{
    color: #13A6B6;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue